<template>
  <client-only>
    <div :class="$style['country-block-wrap']">
      <el-dialog
        :model-value="kycCountryLimitDialogShow"
        :class="$style['modal-dialog']"
        :modal-append-to-body="true"
        @close="onClose"
        :title="$t('kyc.notice')"
      >
        <div :class="$style['show-country-block-container']">
          <div :class="$style['show-country-block-title']">
            {{ $t('common.countryblock_tit__dear') }}
            <template v-if="kycLimitCountryType === 'earn'">
              <br />
              <br />
              {{ $t('common.countryblock_tit_earn') }}
            </template>
            <template v-else-if="kycLimitCountryType === 'dual'">
              <br />
              <br />
              {{ $t('common.countryblock_tit_dual') }}
            </template>
            <template v-else-if="kycLimitCountryType === 'margin'">
              <br />
              <br />
              {{ $t('margin.country_limit') }}
            </template>
            <template v-else>
              <br />
              <KycLimitCountry :country-list="countrys" />
            </template>
          </div>
        </div>
      </el-dialog>
    </div>
  </client-only>
</template>

<script>
import { mapState } from '~/common/js/patch'
import { countryNameMap } from '~/common/js/country-name'
import { getActionLimitCountry } from '~/common/js/helper'
import KycLimitCountry from '@/components/kyc/KycLimitCountry.vue'
import { usePatchStore } from '@/common/js/patch'

export default {
  name: 'KycCountryLimitDialog',
  data() {
    return {
      countryBlockList: [],
    }
  },
  mounted() {
    getActionLimitCountry().then((countryList) => {
      let limitCountries = []
      countryList.forEach((code) => {
        const countryItem = countryNameMap[code]
        if (countryItem) {
          limitCountries.push(countryItem)
        }
      })
      this.countryBlockList = limitCountries
    })
  },
  computed: {
    ...mapState({
      kycCountryLimitDialogShow: (state) => state.kycCountryLimitDialogShow,
      locale: (state) => state.locale,
      kycLimitCountryType: (state) => state.kycLimitCountryType,
      kycLimitCountryList: (state) => {
        let limitCountries = []
        state.kycLimitCountryCodeList.forEach((code) => {
          const countryItem = countryNameMap[code]
          if (countryItem) {
            limitCountries.push(countryItem)
          }
        })
        return limitCountries
      },
      countrys() {
        return this.kycLimitCountryList.length > 0 ? this.kycLimitCountryList : this.countryBlockList
      },
    }),
  },
  methods: {
    onClose() {
      this.store.commit('HIDE_KYC_COUNTRY_LIMIT_DIALOG')
    },
  },
  components: {
    KycLimitCountry,
  },
  setup() {
    const { store } = usePatchStore()
    return {
      store
    }
  },
}
</script>

<style lang="less" module>
@import '../../common/css/theme.less';
.country-block-wrap {
  .modal-dialog {
    width: 90%;
    max-width: 720px;
    border-radius: 8px;
    background-color: #fff;
    margin-top: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    :global {
      .el-dialog__header {
        padding: 32px 32px 8px 32px;
      }
      .el-dialog__body {
        padding: 0 32px;
        padding-bottom: 32px;
      }
    }

    .show-country-block-title {
      font-size: 16px;
      line-height: 20px;
      word-break: break-word;
    }
    .show-country-block-container {
      text-align: left;
      .show-country-block-btn-container {
        text-align: center;
      }
    }
    .el-dialog__header {
      .el-dialog__headerbtn {
        display: none;
      }
    }
  }
  .show-country-block-btn {
    background: @green_text1;
    color: @white_text1;
    border: 1px solid @green_text1;
    border-radius: 1px;
    height: 48px;
    max-width: 280px;
    width: 100%;
    text-align: center;
    padding: 0 20px;
  }
  .show-country-block-btn:hover {
    color: @white_text1;
    opacity: 0.7;
  }
}
</style>
